module.exports = __webpack_public_path__ + "static/media/weather.bdd5a4ff.svg";